import React, { useEffect } from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import VeteransAffairsDetails from '../mendepartmentdetails/VeteransAffairs'


function VeteransAffairs() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Veterans Affairs || State of GTS";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="home"
            title="Veterans Affairs"
            subtitledown="Department of Veterans Affairs"
           />
            <VeteransAffairsDetails/>
        </div>
    </>
  )
}

export default VeteransAffairs